import type { PolygonPoint } from "@shared/schema";

/**
 * Apartment status presentation: Hungarian labels, status-coloured overlay
 * fills/strokes and the availability note shown for non-free units. Kept in
 * one place so the floor-plan SVG zones, the legend and the modal stay in sync.
 *
 * Colours per spec: szabad = zöld, foglalt = piros, fenntartott = sárga.
 */
export const STATUS_LABEL: Record<string, string> = {
  available: "Szabad",
  occupied: "Foglalt",
  reserved: "Fenntartott",
};

export const STATUS_FILL: Record<string, string> = {
  available: "rgba(34,197,94,0.32)", // green
  occupied: "rgba(239,68,68,0.34)", // red
  reserved: "rgba(234,179,8,0.34)", // yellow
};

export const STATUS_STROKE: Record<string, string> = {
  available: "#16a34a",
  occupied: "#dc2626",
  reserved: "#ca8a04",
};

/** Availability message shown in the modal for non-available units. */
export const STATUS_AVAILABILITY: Record<string, string> = {
  occupied: "Ez a lakás már elkelt, jelenleg nem elérhető.",
  reserved: "Ez a lakás fenntartva — érdeklődjön az esetleges elérhetőségről.",
};

export function statusLabel(status: string): string {
  return STATUS_LABEL[status] ?? status;
}

/** SVG polygon `points` attribute from normalized 0..1 vertices (× 100 viewBox). */
export function svgPoints(points: PolygonPoint[]): string {
  return points.map((p) => `${p.x * 100},${p.y * 100}`).join(" ");
}
